import { AnimatePresence } from "framer-motion";
import { useRouter } from "next/router";
import posthog from "posthog-js";

import ChatImmersive from "./ChatImmersive";
import ChatPullTab from "./ChatPullTab";
import ChatSidebar from "./ChatSidebar";
import useChatController from "~/hooks/useChatController";
import useGlobalStore from "~/hooks/useGlobalStore";

// The AI Tutor is only available on content detail pages:
// Course, Article, Video, Glossary Term, and Certification.
const CONTENT_PAGE_ROUTES = [
	"/courses/[slug]",
	"/articles/[slug]",
	"/videos/[slug]",
	"/glossary/[slug]",
	"/certifications/[certificationSlug]",
];

const ChatWidget = () => {
	const { pathname } = useRouter();
	const { isChatBarOpen, isChatImmersive, openChatBar } = useGlobalStore();
	const controller = useChatController();

	if (!CONTENT_PAGE_ROUTES.includes(pathname)) return null;

	const handleOpen = () => {
		posthog.capture("ai_tutor:opened", { source: "pull_tab", pathname });
		openChatBar();
	};

	return (
		<>
			{!isChatBarOpen && <ChatPullTab onOpen={handleOpen} />}
			<AnimatePresence>
				{isChatBarOpen && !isChatImmersive && (
					<ChatSidebar key="sidebar" controller={controller} />
				)}
				{isChatBarOpen && isChatImmersive && (
					<ChatImmersive key="immersive" controller={controller} />
				)}
			</AnimatePresence>
		</>
	);
};

export default ChatWidget;
